import { useState, useEffect } from 'react'
import { SimpleGrid, Title, Loader, Center } from '@mantine/core'
import { IconUsers, IconBook, IconVideo, IconSchool, IconCreditCard, IconArticle } from '@tabler/icons-react'
import StatsCard from '@/components/StatsCard'
import { api } from '@/lib/api'

export default function Dashboard() {
  const [stats, setStats] = useState<Record<string, number> | null>(null)

  useEffect(() => {
    api.admin.dashboard().then(setStats).catch(console.error)
  }, [])

  if (!stats) {
    return <Center h={300}><Loader /></Center>
  }

  return (
    <div>
      <Title order={2} mb="lg">Хянах самбар</Title>
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md">
        <StatsCard label="Хэрэглэгчид" value={stats.users} icon={<IconUsers size={24} />} />
        <StatsCard label="Сургалтууд" value={stats.courses} icon={<IconBook size={24} />} color="blue" />
        <StatsCard label="Видео" value={stats.videos} icon={<IconVideo size={24} />} color="violet" />
        <StatsCard label="Багш нар" value={stats.teachers} icon={<IconSchool size={24} />} color="teal" />
        <StatsCard label="Идэвхтэй захиалга" value={stats.subscriptions} icon={<IconCreditCard size={24} />} color="green" />
        <StatsCard label="Нийтлэлүүд" value={stats.posts} icon={<IconArticle size={24} />} color="pink" />
      </SimpleGrid>
    </div>
  )
}
